<template>
  <div>
    <div>
      <el-input
        placeholder="请选择房号"
        v-popover:resourcePopover
        suffix-icon="el-icon-arrow-down"
        @input="houseChange"
        clearable
        v-model="resourceName"
      ></el-input>

      <el-popover
        placement="bottom-start"
        popper-class="resource_drop__tree"
        ref="resourcePopover"
        v-model="popVisible"
        @show="isNotChangeProject = true"
        trigger="click"
      >
        <resource-tree
          :project-id="projectId"
          :project-name="projectName"
          v-model="resource"
          @input="resourceChange"
          v-if="projectId && isNotChangeProject"
        ></resource-tree>
        <el-alert title="请先选择项目" type="warning" :closable="false" show-icon v-else></el-alert>
      </el-popover>
    </div>
  </div>
</template>

<script>
import ResourceTree from "@/components/resource/ResourceTree";

export default {
  name: "ResourceDropTree",
  data() {
    return {
      resource: "",
      isNotChangeProject: true,
      resourceName: "",
      popVisible: false
    };
  },
  props: {
    projectId: {
      type: [String, Number],
      default: ""
    },
    projectName: {
      type: String,
      default: ""
    },
    holderText: {
      type: String
    }
  },
  methods: {
    resourceChange(data) {
      this.resourceName = data.name;
      this.popVisible = false;
      this.$emit("input", data);
    },
    houseChange(data) {
      this.$emit("input", { name: data, resourceId: "" });
    }
  },
  components: {
    ResourceTree
  },
  watch: {
    projectId() {
      this.isNotChangeProject = false;
      this.popVisible = false;
      this.resourceName = "";
    }
  }
};
</script>

<style>
.resource_drop__tree {
  resize: horizontal;
  overflow: hidden;
  width: 300px;
}
</style>